import { useContext } from 'react'
import { I18nContext, I18nContextValue } from './I18nProvider'
import { getLang, getTexts, locale } from './getTexts'
import { languageList } from './languages'

/**
 * Texts of the active language for a component:
 *
 *   const { t } = useTexts()
 *   <PageHeader title={t.calendarNotes.page.title} />
 *
 * Outside the I18nProvider (unit tests, isolated renders) it returns the current
 * texts without switching.
 */
export function useTexts(): I18nContextValue {
    const ctx = useContext(I18nContext)
    if (ctx) return ctx
    return {
        t: getTexts(),
        lang: getLang(),
        locale: locale(),
        setLang: async () => {},
        languages: languageList(),
    }
}
